import { useRef } from "react";
import "./ProfilePhotoUpload.css";

function ProfilePhotoUpload({
  providerData,
  setProviderData,
}) {

  const fileInputRef = useRef(null);

  const handleFile = (file) => {

    if (!file) return;

    setProviderData({

      ...providerData,

      photos: {

        ...providerData.photos,

        profilePhoto: file,

      },

    });

  };

  const openGallery = () => {

    fileInputRef.current.click();

  };

  const removePhoto = () => {

    setProviderData({

      ...providerData,

      photos: {

        ...providerData.photos,

        profilePhoto: null,

      },

    });

  };

  const image = providerData.photos?.profilePhoto;

  return (

    <div className="profile-upload">

      <h3>

        Profile Photo *

      </h3>

      {

        image ?

        <img

          className="profile-preview"

          src={URL.createObjectURL(image)}

          alt="Profile"

        />

        :

        <div className="profile-placeholder">

          👤

        </div>

      }

      <div className="profile-buttons">

        <label className="upload-btn">

          📷 Take Photo

          <input

            type="file"

            accept="image/*"

            capture="user"

            hidden

            onChange={(e)=>

              handleFile(

                e.target.files[0]

              )

            }

          />

        </label>

        <button

          type="button"

          onClick={openGallery}

        >

          🖼 Upload Photo

        </button>

        {

          image &&

          <button

            type="button"

            className="remove-btn"

            onClick={removePhoto}

          >

            🗑 Remove

          </button>

        }

      </div>

      <input

        ref={fileInputRef}

        hidden

        type="file"

        accept="image/*"

        onChange={(e)=>

          handleFile(

            e.target.files[0]

          )

        }

      />

    </div>

  );

}

export default ProfilePhotoUpload;